import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../Auth/AuthProvider';
import './HamburgerMenu.css';

const HamburgerMenu = ({ onCreateQuiz, onGoToMyPage }) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const { user } = useAuth();

  const toggleOpen = () => setOpen((v) => !v);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    if (open) {
      document.addEventListener('keydown', onKeyDown);
      // prevent body scroll when sidebar is open
      const previous = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.removeEventListener('keydown', onKeyDown);
        document.body.style.overflow = previous;
      };
    }
    return undefined;
  }, [open]);

  const handleCreateQuiz = () => {
    if (onCreateQuiz) onCreateQuiz();
    setOpen(false);
  };

  const handleGoToMyPage = () => {
    try {
      if (onGoToMyPage && window.location.pathname !== '/public') {
        onGoToMyPage();
      } else {
        // Move to root so App renders main layout where my-page can be shown
        window.location.href = '/';
        // After reload, App can route to my-page via header or another click
      }
    } finally {
      setOpen(false);
    }
  };

  const handleLogin = () => {
    window.location.href = '/?tab=login';
    setOpen(false);
  };

  const handleSignUp = () => {
    window.location.href = '/?tab=signup';
    setOpen(false);
  };

  const handlePublicQuizList = () => {
    window.location.href = '/public';
    setOpen(false);
  };

  return (
    <div className="hamburger-menu" ref={menuRef}>
      <button
        className={`hamburger-button ${open ? 'open' : ''}`}
        aria-label="メニュー"
        aria-expanded={open}
        onClick={toggleOpen}
      >
        <span />
        <span />
        <span />
      </button>

      {open && <div className="sidebar-overlay" onClick={() => setOpen(false)} aria-hidden="true" />}

      <nav className={`sidebar ${open ? 'open' : ''}`} aria-label="メインメニュー">
        <div className="sidebar-header">
          <span className="sidebar-title">メニュー</span>
          <button className="sidebar-close" aria-label="閉じる" onClick={() => setOpen(false)}>×</button>
        </div>

        {onCreateQuiz && user && (
          <>
            <button className="menu-item strong" onClick={handleCreateQuiz}>
              + クイズを作成
            </button>
            <div className="menu-divider" />
          </>
        )}

        {user && (
          <button className="menu-item" onClick={handleGoToMyPage}>
            マイページ
          </button>
        )}

        {!user && (
          <>
            <button className="menu-item" onClick={handlePublicQuizList}>
              公開クイズ一覧
            </button>
            <div className="menu-divider" />
            <button className="menu-item" onClick={handleLogin}>
              ログイン
            </button>
            <button className="menu-item" onClick={handleSignUp}>
              アカウント作成
            </button>
          </>
        )}

      </nav>
    </div>
  );
};

export default HamburgerMenu;
